import * as stylex from "@stylexjs/stylex";
import { useRTL } from "hooks";
import { findArticleAlias, useAlias } from "routes";
import { breakpoints, colors } from "../materials/consts.stylex";
import { O, pipe } from "../prelude";
const gemLogoPath = new URL("../assets/gem-report-logo.svg", import.meta.url).href;
const riseLogoPath = new URL("../assets/rise-logo.svg", import.meta.url).href;
const GemUnifsLogoImg = (props)=>{
    return <img alt="" src={gemLogoPath} {...props}/>;
};
const RiseUnifsLogoImg = (props)=>{
    return <img alt="" src={riseLogoPath} {...props}/>;
};
const styles = {
    waveShapeRoot: {
        kzqmXN: "x1guw455 x1ukl5yy",
        kZKoxP: "xsdox4t x1apfdmq",
        $$css: true
    },
    waveTransformLtrNormal: {
        k3aq6I: "xw0x9pr",
        $$css: true
    },
    waveTransformLtrFlipped: {
        k3aq6I: "xdqaewy",
        $$css: true
    },
    waveTransformRtlNormal: {
        k3aq6I: "xddwl7n",
        $$css: true
    },
    waveTransformRtlFlipped: {
        k3aq6I: "xaiei85",
        $$css: true
    }
};
function WaveShape(props) {
    const { flipped, ...svgProps } = props;
    const isRTL = useRTL();
    const transformVariant = isRTL ? flipped ? styles.waveTransformRtlFlipped : styles.waveTransformRtlNormal : flipped ? styles.waveTransformLtrFlipped : styles.waveTransformLtrNormal;
    const svgProps_ = stylex.props(styles.waveShapeRoot, transformVariant);
    return <svg {...svgProps} className={[
        svgProps_.className,
        svgProps.className
    ].filter(Boolean).join(" ")} style={{
        ...svgProps_.style,
        ...svgProps.style
    }}>
      <path d="M0,0 L38,0 L38,48 L37.5272547,48 C31.0243351,48 25.0270245,44.492488 21.8388951,38.8247023 L0,0 Z" className="x2m8lxw x1iq1zl9 x1lliihq xov15ge"/>
      <path d="M76.329 95c-15.332 0-29.138-8.822-36.032-21.47L-.28-.008H76.33V495z" className="x2m8lxw x1iq1zl9 x1s85apg xbh2guc"/>
    </svg>;
}
/**
 * Displays the red banner containing the secondary brands
 *
 * - By default it overlaps the content only a  wider screen since on wider screens
 *   the brands are outside the middle of the page
 * - By default, on smaller screens, it will not overlap since otherwise the brands
 *   would overlap the actual content of the page
 * - Indexes page for countries and indicators force the overlapping since they
 *   have no content to be overlapped
 *
 * This is why there is both the concept of implicit overContent (default) and
 * explicitOverContent (indexes page) along with the responsive definitions.
 *
 * It can be flipped vertically for example for the home page.
 */ const SecondaryBrandsBanner = ({ flipped, overContent = true, ...props })=>{
    // const implicitOverContent = overContent !== false;
    // const explicitOverContent = overContent === true;
    const isRTL = useRTL();
    const alias = useAlias();
    const aliasRouteO = findArticleAlias(alias);
    const logos = pipe(aliasRouteO, O.fold(()=>[
            GemUnifsLogoImg
        ], (route)=>route === "trajectories" ? [
            GemUnifsLogoImg,
            RiseUnifsLogoImg
        ] : [
            GemUnifsLogoImg
        ]));
    return <div data-screenshot-hide className="x78zum5 xdt5ytf xxz18i5 xk6325z xh8yej3 x47corl" style={{
        position: overContent ? "absolute" : "relative"
    }} {...props}>
      {flipped ? null : <div className="xlrawln xneocv9 xmkeg23 x1y0btm7 x1xfaj9i"/>}
      <div className="x1y332i5 x1n2onr6 x78zum5 x13a6bvl xsdox4t x1apfdmq x1awj2ng x4vbgl9">
        <WaveShape flipped={flipped}/>
        <div {...{
        0: {
            className: "x78zum5 x1hb08if x6s0dn4 x5yr21d xneocv9 xmkeg23 x1y0btm7 x1xfaj9i xy13l1i"
        },
        1: {
            className: "x78zum5 x1hb08if x6s0dn4 x5yr21d xneocv9 xmkeg23 x1y0btm7 x1xfaj9i x163pfp"
        }
    }[!!isRTL << 0]}>
          {logos.map((Logo, index)=><Logo key={index} {...{
            0: {
                className: "x39lw6i xe3nupj x1n2onr6 x1ewf8cd x1wsuqlk xre1var"
            },
            2: {
                className: "x39lw6i xe3nupj x1n2onr6 x13kwc0z x1wsuqlk xre1var"
            },
            1: {
                className: "x39lw6i xe3nupj x1n2onr6 x1ewf8cd x1tpqehw x161wy6y"
            },
            3: {
                className: "x39lw6i xe3nupj x1n2onr6 x13kwc0z x1tpqehw x161wy6y"
            }
        }[!!flipped << 1 | !!isRTL << 0]}/>)}
        </div>
      </div>
      {flipped ? <div className="xlrawln xneocv9 xmkeg23 x1y0btm7 x1xfaj9i"/> : null}
    </div>;
};
export default SecondaryBrandsBanner;
